import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function MessageBell({ className = '' }) {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    fetchUnreadCount();
    // Poll every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => {
      clearInterval(interval);
      setMounted(false);
    };
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const headers = getAuthHeaders();
      if (!headers.Authorization) return;
      
      const response = await axios.get(`${API}/messages/unread-count`, { headers });
      if (mounted || true) {  // Always update on mount
        setUnreadCount(response.data.count || 0);
      }
    } catch (error) {
      // Silently fail - user might not be logged in yet
    }
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => navigate('/messages')}
      className={`relative ${className}`}
      title="Хабарламалар"
    >
      <Bell className="h-4 w-4" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Button>
  );
}
